{
  "sections": {
    "hero": "Portfolio",
    "about": "À propos",
    "experience": "Expérience",
    "education": "Éducation",
    "skills": "Compétences",
    "projects": "Projets",
    "talks": "Conférences",
    "contact": "Contact"
  },
  "hero": {
    "headline": "Développeuse Front-end",
    "description": "Professionnelle du développement web, construisant des sites web accessibles et performants avec un accent sur l'expérience utilisateur."
  },
  "about": {
    "headline": "Un peu à propos de moi",
    "paragraphs": [
      "J'ai commencé à programmer en expérimentant avec des applications de télévision numérique en 2011, et depuis je n'ai jamais arrêté. J'ai eu l'opportunité d'apprendre une variété de langages à l'université, du C et C++ au SML et VHDL, mais j'ai trouvé ma passion dans le développement web, où je peux combiner ma créativité avec mes compétences techniques pour créer des expériences engageantes pour les utilisateurs.",
      "J'ai plus de {programming} années de programmation et {professional} années d'expérience professionnelle dans le développement web avec JavaScript/TypeScript, où j'ai travaillé avec de nombreuses technologies et frameworks, y compris Vue, Angular, Nuxt et Astro. J'ai également travaillé occasionnellement avec des technologies back-end telles que .NET Core, Django et Node."
    ]
  },
  "experience": [
    {
      "title": "Ecosia",
      "link": "https://ecosia.org",
      "duration": "avr 2021 - aujourd'hui",
      "intro": "Ingénieure Front-end",
      "description": "Je travaille comme ingénieure front-end pour le moteur de recherche qui plantent des arbres. J'utilise JavaScript avec Vue, Nuxt et Vite, ainsi que HTML et SCSS pour la création de pages web, tant statiques que côté serveur. J'évalue la performance et l'accessibilité de ces pages, garantissant leur intégrité par des tests, et je m'assure que nous offrons des expériences agréables à nos utilisateurs."
    },
    {
      "title": "Symbaros",
      "link": "https://symbaros.com.br",
      "duration": "août 2020 - mars 2022",
      "intro": "Consultante",
      "description": "J'ai travaillé en tant que consultante architecte front-end pour une plateforme spécialisée dans la location d'espaces commerciaux à l'aide d'une intelligence artificielle. J'ai choisi la technologie et l'architecture de l'ensemble des pages web, en utilisant VueJS comme base, et j'ai créé des intégrations avec des APIs pour récupérer des informations relatives aux recherches de biens immobiliers et à leurs attributs."
    },
    {
      "title": "Questrade",
      "link": "https://www.questrade.com/home",
      "duration": "juin 2020 - déc 2020",
      "intro": "Ingénieure Front-end",
      "description": "J'ai travaillé en tant qu'ingénieure front-end pour une plateforme financière canadienne spécialisée dans le trading, en utilisant TypeScript, Angular8+, et SCSS pour offrir des expériences performantes et sécurisées à ses utilisateurs."
    },
    {
      "title": "BLiP.ai",
      "link": "https://blip.ai",
      "duration": "juin 2019 - mai 2020",
      "intro": "Développeuse Full Stack",
      "description": "J'ai travaillé en tant que développeuse full stack dans la plateforme de construction de chatbots BLiP.ai, utilisant AngularJS et VueJS pour le front-end, .NET Core pour le back-end, et Python pour l'analyse de modèles de traitement du langage naturel, ainsi que pour la création d'une API en Django afin de permettre des requêtes vers des modèles entraînés."
    },
    {
      "title": "BLiP.ai",
      "link": "https://blip.ai",
      "duration": "jan 2018 - mai 2019",
      "intro": "Stagiaire en Informatique",
      "description": "J'ai travaillé en tant interne en informatique dans la plateforme de construction de chatbots BLiP.ai utilisant des frameworks AngularJS et VueJS, j'ai fourni des solutions sur l'intelligence artificielle en utilisant Python, et j'ai analysé des modèles de traitement du langage naturel basés sur des intentions et entités."
    }
  ],
  "education": {
    "institution": "Universidade Federal de Minas Gerais (UFMG)",
    "year": "2021",
    "degree": "Licence",
    "field": "Informatique"
  },
  "skills": {
    "programming": "Programmation",
    "web": {
      "title": "Web",
      "set": [
        "Performance",
        "Accessibilité",
        "Responsivité"
      ]
    },
    "frameworks": "Frameworks",
    "tools": "Outils",
    "testing": "Tests",
    "databases": "Bases de données",
    "languages": {
      "title": "Langues",
      "set": [
        "Anglais (Courant)",
        "Portugais (Natif)",
        "Français (Compétent)"
      ]
    }
  },
  "projects": [
    {
      "name": "Altomata",
      "image": "altomata.gif",
      "link": "https://altomata.github.io",
      "description": "Un simulateur d'automates cellulaires construit avec VueJS et TypeScript, permettant aux utilisateurs de créer et de visualiser des règles, des motifs et des évolutions d'automates cellulaires."
    }
  ],
  "talks": [
    {
      "event": "The Developer's Conference",
      "link": "https://thedevconf.com/tdc/2019/belohorizonte/trilha-inteligencia-artificial",
      "date": "14 Juin 2019",
      "title": "Word Embedding et Application",
      "description": "Comment développer une application pour résoudre un problème récurrent de traitement du langage naturel utilisant l'algorithme Word Embedding? Nous explorons la correction orthographique."
    },
    {
      "event": "Developer Circle",
      "link": "https://devcbhmeetupfev2019.splashthat.com/",
      "date": "19 Fev 2019",
      "title": "Comment Apprendre en Utilisant un Texte?",
      "description": "Pour utiliser les mots en modèle mathématique, nous comptons sur leur transformation en une forme de représentation numérique. Un des nombreux algorithmes qui réalise cette tâche est le Word Embedding."
    }
  ],
  "read": "Lire",
  "contact": {
    "prompt": "Parlons-en.",
    "description": "Si vous représentez une organisation à but non lucratif à la recherche de bénévoles, ou si vous faites partie d'un groupe défavorisé ou discriminé ayant besoin de mentorat, je serai heureuse de donner un coup de main."
  },
  "footer": {
    "rights": "Tous droits réservés."
  }
}
